import { IPaymentTermResponse, IPaymentTermsTableData } from '.';
import { IListingData } from '@models/listing';
import { isEmpty } from '@utils/validationUtils';

export function mapToListingData(
  data: IPaymentTermResponse[],
  categories: Record<string, string>
): IListingData {
  if (isEmpty(data))
    return {
      pagedItems: {},
      pageSize: 5,
      pageNumber: 0,
      totalCount: 0,
    };

  const finalList: Record<string, IPaymentTermsTableData> = {};

  data?.forEach((obj: IPaymentTermResponse) => {
    const billType = obj.parentBill_ParentBillCategory;
    const policyName = `${obj.parentBill_PolicyID?.views?.Production_all?.properties?.PolicyNumber} ${obj.parentBill_PolicyID?.views?.Production_all?.properties?.CertificateNumber}`;
    finalList[obj.parentBill_Id] = {
      id: obj.parentBill_Id,
      billType: categories[billType],
      reference:
        billType === 'PRODUCTION'
          ? policyName
          : `${policyName} ${obj.linkedAmendment_AmendmentNumber}`,
      totalPremium: obj.parentBill_TotalPremium,
      amountReceived: obj.parentBill_TotalAmountReceived,
      amountPaid: obj.parentBill_TotalAmountPaid,
      amountDue: obj.parentBill_TotalAmountDue,
      commission: obj.parentBill_TotalCommission,
      taxOnCommission: obj.parentBill_TotalTaxOnCommission,
      linkedAmendmentId: obj?.linkedAmendment_Id,
      linkedAmendment: obj.linkedAmendment_AmendmentNumber,
      linkedAmendmentEffectiveDate: obj.linkedAmendment_AmendmentEffectiveDate,
      Currency: obj.parentBill_Currency?.Symbol,
      viewBreakdown: 'View Breakdown',
      AvailableActions:
        !isNaN(obj.parentBill_TotalAmountDue) &&
        Number(obj.parentBill_TotalAmountDue) > 0
          ? ['changepaymentterms']
          : [],
    };
  });

  return {
    pagedItems: finalList,
    pageSize: 5,
    pageNumber: 1,
    totalCount: Object.keys(finalList).length,
  };
}
